// extracted by mini-css-extract-plugin
module.exports = {"container":"floatBottomTips_container__h3H4G","text":"floatBottomTips_text__In_pu","right":"floatBottomTips_right__li8ds"};